module.exports = __webpack_public_path__ + "static/src/nrl-teams/images/dragons.a586626.png";


//////////////////
// WEBPACK FOOTER
// ./src/nrl-teams/images/dragons.png
// module id = s3z7
// module chunks = 0